<template>
  <DropdownWrapper
    v-if="internal"
    v-click-outside="hideDropdown"
    position="bottom"
    alignment="right"
    class="pb-header-content-dropdown-wrapper"
    :enable="dropdownActive"
    @close="hideDropdown"
  >
    <template #toggler>
      <ControlButton
        v-tooltip="{ text: label, position: 'bottom' }"
        :aria-label="label"
        icon="icon-download"
        :class="{
          'btn-info': dropdownActive,
        }"
        @click="toggleDropdown"
      />
    </template>
    <template #dropdown>
      <Transition name="fade">
        <DropdownContent
          v-if="dropdownActive"
          class="pb-header-content-dropdown pb-header-content-profile-download-dropdown"
        >
          <PbInput
            v-model="enableOptimization"
            :type="INPUT_TYPE_SWITCH"
            class="pb-export-global-channel-switch"
            :label="translate('pb2.downloadProfile.enableOptimizations')"
          />
          <ButtonGroup
            padded
            row
          >
            <ControlButton
              label="SSL2"
              :to="downloadLinks.ssl2"
              target="_blank"
            />
            <ControlButton
              label="WMP"
              :to="downloadLinks.wmp"
              target="_blank"
            />
            <ControlButton
              label="XML"
              :to="downloadLinks.xml"
              target="_blank"
            />
            <ControlButton
              label="JSON"
              :to="downloadLinks.json"
              target="_blank"
            />
          </ButtonGroup>
        </DropdownContent>
      </Transition>
    </template>
  </DropdownWrapper>
  <ControlButton
    v-else
    v-tooltip="{ text: label, position: 'bottom' }"
    :disabled="!enabled"
    :aria-label="label"
    icon="icon-download"
    :to="downloadLinks.ssl2"
    target="_blank"
  />
</template>

<script setup>
import { watch } from 'vue'

import ControlButton from '@nicolaudie-group/ng-ui-kit/components/ControlButton/ControlButton.vue'
import DropdownWrapper from '@nicolaudie-group/ng-ui-kit/components/Dropdown/DropdownWrapper.vue'
import DropdownContent from '@nicolaudie-group/ng-ui-kit/components/Dropdown/DropdownContent.vue'
import { INPUT_TYPE_SWITCH } from '@nicolaudie-group/ng-ui-kit/components/BaseInput/symbols'

import useToggle from '@nicolaudie-group/ng-ui-kit/composables/useToggle'
import useCloseOthers from '@nicolaudie-group/ng-ui-kit/composables/useCloseOthers'
import useHotkeys, { KEYS } from '@nicolaudie-group/ng-ui-kit/composables/useHotkeys'

import ButtonGroup from '@/components/ButtonGroup/ButtonGroup.vue'

import useReducedState from '@/composables/useReducedState'
import useProfileDownload from '@/composables/useProfileDownload'
import useTranslate from '@/composables/useTranslate'
import PbInput from '@/components/PbInput.vue'
import vClickOutside from '@nicolaudie-group/ng-ui-kit/directives/vClickOutside'
import vTooltip from '@nicolaudie-group/ng-ui-kit/directives/vTooltip'

const { translate } = useTranslate()

const {
  enableOptimization,
  downloadLinks,
  label,
  enabled,
  internal,
} = useProfileDownload()

const {
  state: dropdownActive,
  toggle: toggleDropdown,
  off: hideDropdown,
} = useToggle(false)
useCloseOthers(hideDropdown, dropdownActive)
useReducedState(dropdownActive, 'dropdowns')

const { active: escapePressed } = useHotkeys(KEYS.Escape, {
  shift: false,
  alt: false,
  meta: false,
  ctrl: false,
  exact: true,
  disableInTextarea: true,
  disableInInput: true,
})

watch(escapePressed, (pressed) => {
  if (pressed) {
    hideDropdown()
  }
})

</script>
